'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { Course } from '@/types/CoursesV2Response';
import { useLocalStorage } from './use-location-storage';
export interface FavouriteCourse {
  course: Course;
  org: string;
}
export function useFavourites() {
  const $ = _c(17);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [favourites, setFavourites] = useLocalStorage("favouriteCourses", t0);
  let t1;
  if ($[1] !== favourites) {
    t1 = courseId => favourites.some(fav => fav.course.EventId === courseId);
    $[1] = favourites;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const isFavourite = t1;
  let t2;
  if ($[3] !== setFavourites) {
    t2 = (course, org) => {
      setFavourites(prev => {
        if (prev.some(fav_0 => fav_0.course.EventId === course.EventId)) {
          return prev;
        }
        return [...prev, {
          course,
          org
        }];
      });
    };
    $[3] = setFavourites;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const addFavourite = t2;
  let t3;
  if ($[5] !== setFavourites) {
    t3 = courseId_0 => {
      setFavourites(prev_0 => prev_0.filter(fav_1 => fav_1.course.EventId !== courseId_0));
    };
    $[5] = setFavourites;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const removeFavourite = t3;
  let t4;
  if ($[7] !== addFavourite || $[8] !== isFavourite || $[9] !== removeFavourite) {
    t4 = (course_0, org_0) => {
      if (isFavourite(course_0.EventId)) {
        removeFavourite(course_0.EventId);
      } else {
        addFavourite(course_0, org_0);
      }
    };
    $[7] = addFavourite;
    $[8] = isFavourite;
    $[9] = removeFavourite;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const toggleFavourite = t4;
  let t5;
  if ($[11] !== addFavourite || $[12] !== favourites || $[13] !== isFavourite || $[14] !== removeFavourite || $[15] !== toggleFavourite) {
    t5 = {
      favourites,
      isFavourite,
      addFavourite,
      removeFavourite,
      toggleFavourite
    };
    $[11] = addFavourite;
    $[12] = favourites;
    $[13] = isFavourite;
    $[14] = removeFavourite;
    $[15] = toggleFavourite;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}